import { types } from './mutation-types';

export const steps = {
  namespaced: true,
  state: {
    stepsList: ['Zamówienie', 'Logowanie / Rejestracja', 'Dane do faktury', 'Dostawa', 'Informacje dodatkowe', 'Potwierdzenie'],
    /*
    * currentStep [ 0 - 5 ]
    * */
    currentStep: 0,
    shouldDataBeRestored: false,
    stepType: {
      START: 0,
      LOGIN: 1,
      INVOICE: 2,
      DELIVERY: 3,
      ADDITIONAL_INFO: 4,
      SUMMARY: 5,
    },
  },
  getters: {
    currentStep(state) {
      return state.currentStep;
    },
  },
  mutations: {
    [types.SET_CURRENT_STEP](state, payload) {
      state.currentStep = payload;
    },
    handleChangeRestoreFlag(state, newState) {
      state.shouldDataBeRestored = newState;
    },
  },
  actions: {
    setCurrentStep({ commit }, newCurrentStep) {
      commit(types.SET_CURRENT_STEP, newCurrentStep);
    },
    changeRestoreFlag({ commit }, payload) {
      commit('handleChangeRestoreFlag', payload);
    },
  },
};
